import autobind from 'core-decorators/lib/autobind';

import videoSources from 'shared/constants/video-sources';

import Vimeo from '../player/video/external/vimeo';
import Youtube from '../player/video/external/youtube';
import Facebook from '../player/video/external/facebook';


const fullScreenChangeEventsList = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];

const playersMap = {
  [videoSources.YOUTUBE]: Youtube,
  [videoSources.VIMEO]: Vimeo,
  [videoSources.FACEBOOK]: Facebook,
};

export default class ExternalPlayer extends React.Component {

  static propTypes = {
    onFullScreenChanged: React.PropTypes.func,

    videoItem: React.PropTypes.object.isRequired,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    onFullScreenChanged: _.noop,
  };

  componentWillMount() {
    this.addFullscreenEventHandler();
  }

  componentWillUnmount() {
    this.removeFullscreenEventHandler();
  }

  @autobind
  handleFullscreenChange() {
    this.props.onFullScreenChanged(this.isInFullScreen);
  }

  get isInFullScreen() {
    return Boolean(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    );
  }

  addFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.addEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  removeFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.removeEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  render() {
    const { videoItem } = this.props;

    if (!videoItem) {
      return null;
    }

    const { id, externalId, mediaExternUrl, videoSource } = videoItem;

    const props = {
      ...this.props,
      showControls: true,
      src: mediaExternUrl,
    };

    const ExternalPlayer = playersMap[videoSource];

    if (!ExternalPlayer) {
      return null;
    }

    return (
      <ExternalPlayer {...props}
                      key={id || externalId} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/player-external.js